module.exports = __webpack_public_path__ + "img/3_img.e42903b0.png";